import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { IReject, IResolve } from '@df/api/request/request.service';
import { Route } from '@df/catalog/route/route';
import { App } from '@df/core/app';
import { Client } from '@df/core/service/client';
import { Logger } from '@df/core/service/logger';
import { EdependencyLevel } from '../model';

let redirectsSequence: string[] = [];

/**
 * If you want to allow redirect to homepage on 404 then set this hash in url
 */
export const NOT_FOUND_REDIRECT_TO_HP_FLAG = '_nfrd';

@Injectable({
    providedIn: 'root'
})
export class RouteResolver implements Resolve<Route> {
    constructor(
        private router: Router,
        private logger: Logger,
        private client: Client,
        private app: App
    ) {}

    cleanUrl(url: string) {
        return url.replace(/(\?|\#).*$/, '') || '/';
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Route> {
        // this.app.tracker.tick('load route');
        const path = this.cleanUrl(state.url);
        const model = this.app.resources.route.getCreate(path);
        return new Promise((resolve: IResolve, reject: IReject) => {
            model
                .load(1, { dependencyLevel: EdependencyLevel.details })
                .finally(() => {
                    if (model.data?.rewrite && !redirectsSequence.includes(path) && this.client.mode === 'browser') {
                        redirectsSequence.push(path);
                        this.router.navigateByUrl(model.data.rewrite);
                    } else {
                        if (!model.data && route.fragment === NOT_FOUND_REDIRECT_TO_HP_FLAG) {
                            this.router.navigateByUrl('/', { replaceUrl: true });
                            redirectsSequence.push(path);
                            // on error we do want to resolve anyway to show 404
                        } else {
                            // reset sequence
                            redirectsSequence = [];
                            resolve(model);
                        }
                    }
                })
                .catch(e => {
                    this.logger.error('Catalog route resolver error:', e);
                    reject(e);
                });
        });
    }

    /**
     * Preload route model without redirects.
     *
     * @author Rafał Wolak <rafal@tomandco.co.uk>
     * @param {string} path
     * @returns {Promise<Route>}
     * @memberof RouteResolver
     */
    preload(path: string): Promise<Route> {
        return new Promise((resolve: IResolve) => {
            path = path.replace(/(\?|\#).*$/, '') || '/';
            const model = this.app.resources.route.getCreate(path);
            return model.load(1).finally(() => {
                resolve(model);
            });
        });
    }
}
